export const advisor = [
  {
    path: '/a/:alias1',
    isEmbed: false,
    options: false,
  },
  {
    path: '/a/:alias1/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/a/:alias1/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/a/:alias1/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/a/:alias1/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/a/:alias1/embed/options',
    isEmbed: true,
    options: true,
  },
  {
    path: '/a/:alias1/:alias2',
    isEmbed: false,
    options: false,
  },
  {
    path: '/a/:alias1/:alias2/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/a/:alias1/:alias2/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/a/:alias1/:alias2/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/a/:alias1/:alias2/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/a/:alias1/:alias2/embed/options',
    isEmbed: true,
    options: true,
  },
  {
    path: '/advisor/:alias1',
    isEmbed: false,
    options: false,
  },
  {
    path: '/advisor/:alias1/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/advisor/:alias1/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/advisor/:alias1/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/advisor/:alias1/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/advisor/:alias1/embed/options',
    isEmbed: true,
    options: true,
  },
  {
    path: '/advisor/:alias1/:alias2',
    isEmbed: false,
    options: false,
  },
  {
    path: '/advisor/:alias1/:alias2/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/advisor/:alias1/:alias2/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/advisor/:alias1/:alias2/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/advisor/:alias1/:alias2/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/advisor/:alias1/:alias2/embed/options',
    isEmbed: true,
    options: true,
  }
];
